export default __webpack_public_path__ + "static/media/muncie-map.2608e176.jpeg";